import React from 'react';
import PropTypes from 'prop-types';
import styles from './AthleteCategoryBadge.module.css';

// Mirrors the server's guest class (ResultAthleteCategory): Guest and
// WalkUpGuest display as "Guest", Visitor as "Visitor". Full and Unknown
// are club members and get no badge.
const CATEGORY_LABELS = {
  Guest: 'Guest',
  WalkUpGuest: 'Guest',
  Visitor: 'Visitor',
};

const AthleteCategoryBadge = ({ category }) => {
  const label = CATEGORY_LABELS[category];
  if (!label) return null;
  return <span className={styles.badge}>{label}</span>;
};

AthleteCategoryBadge.propTypes = {
  category: PropTypes.string,
};

export default AthleteCategoryBadge;
